import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dt-forms",
  "use": "icon-dt-forms-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dt-forms\"><path d=\"M178.0736 122.88v716.8h716.8v61.44h-778.24V122.88h61.44z\" fill=\"#2c2c2c\" p-id=\"3490\" /><path d=\"M907.3664 208.5376l-275.712 344.6272L454.5536 435.2l-179.2 268.8-51.0976-34.0992 213.248-319.8976 181.3504 120.832 240.5376-300.6464 47.9744 38.4z\" p-id=\"3491\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dt-forms.svg
// module id = xpK1
// module chunks = 67